import React from 'react';
import { Form, Input, Row, Col, Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { maibFormRules } from '../../utils/validation';

const PartnerMAIBInfo = ({ disabled = false }) => {
  return (
    <div>
      <Alert
        message="MAIB Payment Integration"
        description="Configure MAIB payment gateway credentials for this partner. These settings are optional and can be updated later."
        type="info"
        icon={<InfoCircleOutlined />}
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Project ID"
            name="maib_project_id"
            rules={maibFormRules.maib_project_id}
          >
            <Input
              placeholder="Enter MAIB Project ID"
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Project Secret Key"
            name="maib_project_secret_key"
            rules={maibFormRules.maib_project_secret_key}
          >
            <Input.Password
              placeholder="Enter Project Secret Key"
              disabled={disabled}
              autoComplete="new-password"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Signature Key"
            name="maib_signature_key"
            rules={maibFormRules.maib_signature_key}
          >
            <Input.Password
              placeholder="Enter Signature Key"
              disabled={disabled}
              autoComplete="new-password"
            />
          </Form.Item>
        </Col>
      </Row>

      <Alert
        message="Security Notice"
        description="Keep your MAIB credentials secure. Never share them publicly or commit them to version control."
        type="warning"
        showIcon
        style={{ marginTop: 16 }}
      />
    </div>
  );
};

export default PartnerMAIBInfo;
